import { Component, ViewChild, ViewEncapsulation, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../lib/api.service';
import { LogService } from '../../../lib/log.service';
import { ModalService } from '../../../lib/modal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AudioCourse } from '../../../models/course';
import { MultiAutoItem } from 'app/models/multiautoitem';
import { Organization } from 'app/models/organization';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
    selector: 'app-course-admin-audio-edit',
    templateUrl: './course-admin-audio-edit.component.html',
    styleUrls: ['./course-admin-audio-edit.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class CourseAdminAudioEditComponent implements OnInit {
    public Editor = ClassicEditor;
    @ViewChild('input') fileInput: any;
    courseEditForm: FormGroup;
    courseStoryId: number;
    courseKey: string;
    title: string;
    mode: string;
    // course: Course;
    course: AudioCourse;
    isLoaded: boolean = false;
    config: any;
    panelState: Array<boolean>;
    submitButtonPressed: boolean = false;
    errors: string = '';
    categoryList: any = [];
    showFrench = false;
    showSpanish = false;
    showError: boolean = false;
    audioerror: boolean = false;
    seriesPageType: string;
    multiSelOrgs: Array<MultiAutoItem> = [];
    organizations: Organization[];
    constructor(
        private translate: TranslateService,
        private formBuilder: FormBuilder,
        private api: ApiService,
        private log: LogService,
        private modalService: ModalService,
        private route: ActivatedRoute,
        private router: Router,
        private location: Location
    ) {
        const paramId = this.route.snapshot.paramMap.get('id');
        this.courseStoryId = paramId ? +paramId : null;
        this.seriesPageType =
            this.route.snapshot.queryParamMap.get('seriesPageType') || '';
        this.panelState = [];

        if (this.courseStoryId) {
            this.title = 'Edit this Story';
            this.mode = 'update';
        } else {
            this.title = 'Create a Story';
            this.course = new AudioCourse({});
            this.mode = 'create';
            this.isLoaded = true;
        }
        this.getOrganizations();
        this.getCategoryList();
        this.createCourseEditForm(new AudioCourse({}));

        this.config = {
            toolbar: [
                'bold',
                'italic',
                'strikethrough',
                '|',
                'numberedList',
                'bulletedList',
                '|',
                'link',
                'pasteFromOffice',
            ],
        };
    }

    get f() {
        return this.courseEditForm.controls;
    }
    getCategoryList() {
        this.api.get('series/categories').subscribe(
            (result: any) => {
                this.categoryList = result;
                this.isLoaded = true;
            },
            (error: any) => {
                this.log.error('Error getting categories. ' + error.message);
            }
        );
    }

    getOrganizations() {
        this.api.get('admin/organizations', { Active: true }).subscribe(
            (results: any) => {
                this.organizations = Organization.initializeArray(results.data);
                let orgList = [];
                this.organizations.forEach(org => {
                    orgList.push(new MultiAutoItem(org.id, org.name));
                });
                this.multiSelOrgs = [...orgList];
            },
            (error: any) => {
                this.log.error('Error loading. ' + error.message);
            }
        );
    }

    createCourseEditForm(data: any) {
        this.courseEditForm = this.formBuilder.group({
            id: [data.id || null],
            titleen: [data.titleen || '', [Validators.required]],
            titlefr: [data.titlefr || ''],
            titlees: [data.titlees || ''],
            authoren: [data.authoren || '', [Validators.required]],
            authorfr: [data.authorfr || ''],
            authores: [data.authores || ''],
            transcripten: [data.transcripten || '', [Validators.required]],
            transcriptfr: [data.transcriptfr || ''],
            transcriptes: [data.transcriptes || ''],
            isCompleted: [data.isCompleted || false],
            active: [data.active || false],
            audio: this.createFileUpload(data.audio),
            image: this.createFileUpload(data.image),
            audioUrl: [data.audioURL || ''],
            imageUrl: [data.imageURL || ''],
        });

        if (this.seriesPageType !== 'customType') {
            this.courseEditForm.addControl(
                'category',
                this.formBuilder.control(data.category || '', [
                    Validators.required,
                ])
            );
            this.courseEditForm.addControl(
                'default',
                this.formBuilder.control(data.default || false)
            );
        } else {
            this.courseEditForm.addControl(
                'orgIds',
                this.formBuilder.control(data.orgIds || '')
            );
        }

        // if (!data.audioFileUpload || data.audioFileUpload.length === 0) {
        //   this.addAudioFile();
        // } else {
        //   data.audioFileUpload.forEach(file => {
        //     this.addAudioFile(file);
        //   });
        // }
    }

    get audioFileUpload(): FormArray {
        return this.courseEditForm.get('audio') as FormArray;
    }

    // addAudioFile(data: any = {}) {
    //   this.audioFileUpload.push(this.createFileUpload(data));
    // }

    ngOnInit() {
        if (this.courseStoryId) {
            let payLoad = {};
            if (this.seriesPageType == 'customType') {
                payLoad['CourseType'] = 'organization';
            }
            this.api
                .get('series/story/' + this.courseStoryId, payLoad)
                .subscribe(
                    (result: any) => {
                        this.course = new AudioCourse(result[0]);
                        this.isLoaded = true;
                        this.createCourseEditForm(this.course);
                        this.showFrench = !!(
                            this.course.titlefr?.trim() ||
                            this.course.authorfr?.trim() ||
                            this.course.transcriptfr?.trim()
                        );
                        this.showSpanish = !!(
                            this.course.titlees?.trim() ||
                            this.course.authores?.trim() ||
                            this.course.transcriptes?.trim()
                        );
                    },
                    (error: any) => {
                        this.log.error(
                            'Error getting organizations. ' + error.message
                        );
                    }
                );
        }
    }

    changeAudioUploadListener($event): void {
        this.readFile($event.target, 'audio', 'mp3');
    }

    readFile(
        inputValue: any,
        keyFileName: string,
        allowedTypes: string = 'mp3'
    ) {
        var file: File = inputValue.files[0];
        let fileName = file.name;
        var reader: FileReader = new FileReader();
        const maxFileSize = 25 * 1024 * 1024;
        const extPattern = new RegExp(`\.(${allowedTypes})$`, 'i');

        if (!extPattern.test(fileName)) {
            this.modalService.showAlert(
                'Error',
                `Invalid file extension. Allowed: ${allowedTypes}`
            );
            inputValue.value = '';
            return;
        }

        if (file.size > maxFileSize) {
            this.modalService.showAlert(
                'Error',
                `File size exceeds 25MB. Please upload a smaller file.`
            );
            inputValue.value = '';
            return;
        }

        reader.onloadend = () => {
            const audioList = this.courseEditForm.get(keyFileName) as FormGroup;

            audioList.patchValue({
                fileUpload: reader.result,
                fileFilename: fileName,
            });
        };

        reader.readAsDataURL(file);
    }

    courseImageUpload($event) {
        var file: File = $event.target.files[0];
        $event.target.files[0];
        let fileName = $event.target.files[0].name;
        var reader: FileReader = new FileReader();
        const maxFileSize = 5 * 1024 * 1024;
        const courseImage = this.courseEditForm.get('image') as FormGroup;
        if (!/\.(jpg|jpeg)$/i.test(fileName)) {
            this.fileInput.nativeElement.value = '';
            this.modalService.showAlert(
                'Error',
                'Please ensure that the file you are uploading is in .jpg format.'
            );
            return;
        }

        if (file.size > maxFileSize) {
            this.fileInput.nativeElement.value = '';
            this.modalService.showAlert(
                'Error',
                'The file size exceeds the maximum limit of 2MB.'
            );
            return;
        }

        reader.onloadend = () => {
            courseImage.patchValue({
                fileUpload: reader.result,
                fileFilename: fileName,
            });
        };

        reader.readAsDataURL(file);
    }

    validateEditor() {
        const transcriptControl = this.courseEditForm.get('transcripten');

        if (transcriptControl?.value.trim() === '') {
            transcriptControl.setErrors({ required: true });
        } else {
            transcriptControl.setErrors(null);
        }
    }

    doSave() {
        this.course = new AudioCourse(this.courseEditForm.value);
        this.submitButtonPressed = true;
        if (!this.courseEditForm.valid) {
            this.courseEditForm.markAllAsTouched();
            return;
        }
        this.errors = '';
        this.audioerror = false;
        const hasTranscript = ['transcripten'].some(field =>
            this.courseEditForm.get(field)?.value.trim()
        );

        if (!hasTranscript) {
            this.errors =
                'At least one of the Transcript fields (English) must be filled.';
        }

        if (
            !this.courseEditForm.value.audio.fileFilename &&
            !this.courseEditForm.value.audio.fileUpload &&
            !this.courseEditForm.value.audioUrl
        ) {
            this.audioerror = true;
            this.errors = `The audio file is mandatory`;
        }

        if (this.errors || this.audioerror) {
            return;
        }
        this.isLoaded = false;
        if (this.mode === 'update') {
            this.api
                .put(
                    'series/story/' + this.courseStoryId,
                    AudioCourse.forAPI(this.course, this.seriesPageType),
                    true
                )
                .subscribe(
                    (data: any) => {
                        this.modalService.showAlert(
                            'Success',
                            'Series has been updated'
                        );
                        this.isLoaded = true;
                        this.navigateToListingPage();
                    },
                    (error: any) => {
                        this.isLoaded = true;
                        this.modalService.showAlert(
                            'Error',
                            'Something went wrong. ' + error.message
                        );
                    }
                );
        } else {
            this.api
                .post(
                    'series/story',
                    AudioCourse.forAPI(this.course, this.seriesPageType),
                    true
                )
                .subscribe(
                    (data: any) => {
                        this.modalService.showAlert(
                            'Success',
                            'Series has been created'
                        );
                        this.isLoaded = true;
                        this.navigateToListingPage();
                    },
                    (error: any) => {
                        this.isLoaded = true;
                        this.modalService.showAlert(
                            'Error',
                            'Something went wrong. ' + error.message
                        );
                    }
                );
        }
    }

    createFileUpload(data: any) {
        return this.formBuilder.group({
            fileUpload: [data.fileUpload || null],
            fileFilename: [data.fileFilename || ''],
        });
    }

    onClose() {
        this.location.back();
    }

    onSelectOrgs(items: MultiAutoItem[]) {
        let organizationIds = items.map(item => item.id);
        this.courseEditForm.patchValue({
            orgIds: organizationIds,
        });
    }

    navigateToListingPage() {
        if (this.seriesPageType == 'customType') {
            this.router.navigate(['/admin/custom-series-listing']);
        } else {
            this.router.navigate(['/admin/series-listing']);
        }
    }
}
